import styled from 'styled-components/macro';
import { flexbox, layout } from 'styled-system';

import { Box, Button, getColor } from '@olist/united';

export const Wrapper = styled(Box)`
  div:first-child {
    display: block;
  }

  button[data-ref='dropdown-toggle'] {
    border: 1px solid ${getColor('text', 'light', 2)};
    box-shadow: inset 0px 3px 3px rgba(0, 0, 0, 0.05);
    font-weight: normal;
    width: 100%;
  }
`;

export const SelectButton = styled(Button).attrs({
  'data-ref': 'dropdown-toggle',
  'data-testid': 'dropdown-toggle',
  justifyContent: 'space-between',
  maxWidth: '380px',
  type: 'button',
})`
  ${flexbox}
  ${layout}
`;

export const CheckboxWrapper = styled(Box).attrs({
  maxHeight: '464px',
  my: '15px',
})`
  &:first-child {
    margin-top: 0;
  }
`;

export const InvalidSegmentCard = styled.div`
  border: 1px solid #eaeaf4;
  border-radius: 8px;
  color: ${({ theme }) => theme.olist.color.neutral.stronger};
  display: flex;
  flex-direction: row;
  gap: 8px;
  line-height: 24px;
  margin-top: 40px;
  padding: 24px;

  h3 {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: ${({ theme }) => theme.olist.color.neutral.stronger};
  }

  strong {
    font-weight: 800;
  }

  ul {
    list-style-type: disc;
    margin-bottom: 24px;
    margin-left: 16px;
    li {
      line-height: 24px;
    }
  }
`;

export const InvalidSegmentContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
